module.exports = __webpack_public_path__ + "static/media/two.171ae2ff.svg";